import { useEffect, useState } from 'react';
import { getSiteSettings } from '../config/firebase';
import heroImage from '../../src/assets/images/hsi_hero1.png';

const Hero = () => {
  const [bg, setBg] = useState(heroImage);

  useEffect(() => {
    getSiteSettings().then((s) => { if (s.heroImageUrl) setBg(s.heroImageUrl); }).catch(() => {});
  }, []);

  return (
    <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center text-center text-white bg-teal-800">
      {/* <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{backgroundImage: "src/assets/images/hsi_hero.png"}}></div> */}
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src={bg}
          alt="Transportation background"
        />
        <div className="absolute inset-0 bg-gray-900 opacity-75"></div>
      </div>
      <div className="relative z-10 p-6">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight drop-shadow-md">A Smile Shouldn't Cost a Life.</h1>
        <p className="mt-4 text-lg md:text-xl max-w-3xl mx-auto drop-shadow ">We empower local healthcare workers to bring vital medical and dental care to Sierra Leone's most vulnerable communities.</p>
        <div className="mt-8 flex justify-center gap-4">
          <a href="#join-us" className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-stone-100 transition-transform hover:scale-105 shadow-lg">Support Our Mission</a>
          <a href="#story" className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-transform hover:scale-105">Learn Our Story</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;